import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

import "./Header.css";

const Header = () => {
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [isEnVisible, setEnVisible] = useState(false);
  const [isAboutUsVisible, setAboutUsVisible] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen);
  };

  window.addEventListener("scroll", () => {
    const header = document.getElementById("header");
    const scrollPosition = window.scrollY || window.pageYOffset;

    if (scrollPosition > 200) {
      header.classList.add("show");
    } else {
      header.classList.remove("show");
    }
  });
  return (
    <div  className={`header ${menuOpen ? "menu-open" : ""}`}>
      {" "}
      <header id="header" name="header for-main-page">
        <div className="main-content">
          <div className="logo-wrapper">
            <img
              className="logo"
              src="https://www.zazmic.com/wp-content/themes/zazmic/img/logo.svg"
              alt="logo"
            />
            {/* <img class="logo-small" src="https://www.zazmic.com/wp-content/themes/zazmic/img/logo-small.svg"
                alt="logo" /> */}
          </div>
          <div className={`header--menu ${menuOpen ? "open" : ""}`}>
            <div id="header-menu" className="header-menu">
              <nav id="site-navigation" className="main-navigation">
                <div className="menu-menu-1-container">
                  <ul id="primary-menu">
                    <li id="menu-item-21324" className="menu-item">
                      Expertise
                    </li>
                    <li
                      className="menu-item"
                      id="dropdown-menu"
                      onMouseEnter={() => setDropdownVisible(true)}
                      onMouseLeave={() => setDropdownVisible(false)}
                    >
                      Cloud{" "}
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className={`sub-menu-icon ${
                          isDropdownVisible ? "rotate-icon-header" : ""
                        }`}
                        id="svg__icon"
                      />
                      {isDropdownVisible && (
                        <ul className="drop__menu-header">
                          <li>Packages</li>
                          <li>Specialization</li>
                          <li>AI Workshops</li>
                        </ul>
                      )}
                    </li>
                    <li id="menu-item-21324" className="menu-item">
                      Partners
                    </li>
                    <li id="menu-item-21324" className="menu-item">
                      Blog
                    </li>
                    <li
                      className="menu-item"
                      id="dropdown-menu"
                      onMouseEnter={() => setAboutUsVisible(true)}
                      onMouseLeave={() => setAboutUsVisible(false)}
                    >
                      About Us{" "}
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className={`sub-menu-icon ${
                          isDropdownVisible ? "rotate-icon-header" : ""
                        }`}
                        id="svg__icon"
                      />
                      {isAboutUsVisible && (
                        <ul className="drop__menu-header">
                          <li>Who We Are</li>
                          <li>Culture</li>
                          <li>Careers</li>
                        </ul>
                      )}
                    </li>

                    <li id="menu-item-21324" className="menu-item">
                      Contact Us
                    </li>
                    <li id="menu-item-21324" className="menu-item">
                      Login
                    </li>
                    <li
                      className="menu-item"
                      id="dropdown-menu"
                      onMouseEnter={() => setEnVisible(true)}
                      onMouseLeave={() => setEnVisible(false)}
                    >
                      EN{" "}
                      <FontAwesomeIcon
                        icon={faAngleDown}
                        className={`sub-menu-icon ${
                          isDropdownVisible ? "rotate-icon-header" : ""
                        }`}
                        id="svg__icon"
                      />
                      {isEnVisible && (
                        <ul className="drop__menu-header">
                          <li>ES</li>
                          <li>PT</li>
                        </ul>
                      )}
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
          <div className="menu-button" onClick={handleMenuToggle}>
            <div className={`bar ${menuOpen ? "animate" : ""}`}></div>
            <div className={`bar ${menuOpen ? "animate" : ""}`}></div>
            <div className={`bar ${menuOpen ? "animate" : ""}`}></div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default Header;
